module.exports = __webpack_public_path__ + "static/media/3browbomber.b8a53568.png";